import { ApiError } from "@wellcheck/api-client";

// backend (handlers/contactedit.go) が返す detail と同じ文字列。修正期限切れの 409 と区別するために使う。
const CONTACT_EDIT_NOT_ALLOWED_DETAIL = "contact edit not allowed in current status";

// backend (handlers/contactedit.go) が返す detail と同じ文字列。メールアドレス重複の 409 と区別するために使う。
const CONTACT_EDIT_DUPLICATE_EMAIL_DETAIL = "contact edit email already exists";

function contactEditErrorDetail(error: unknown): string | undefined {
  if (!(error instanceof ApiError) || error.status !== 409) {
    return undefined;
  }
  const data = error.data;
  if (typeof data !== "object" || data === null || !("detail" in data)) {
    return undefined;
  }
  return (data as { detail: unknown }).detail as string | undefined;
}

export function isContactEditNotAllowedError(error: unknown): boolean {
  return contactEditErrorDetail(error) === CONTACT_EDIT_NOT_ALLOWED_DETAIL;
}

export function isContactEditDuplicateEmailError(error: unknown): boolean {
  return contactEditErrorDetail(error) === CONTACT_EDIT_DUPLICATE_EMAIL_DETAIL;
}
